import ExcelJS from 'exceljs'
import imgTool from './imgTool'
import savefile from './savefile'
import calcStockAndPrice from './calcStockAndPrice'
const ALPHABET = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
const minimal_base64_img = 'data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

async function exportOrdersToExcel(
  headers: string[],
  headers_key: string[],
  products: { [x: string]: any },
  checkedSubproductArray: number[],
  category_label: string,
  logistic_cny: number | string,//多个表格物流费用注意
  company: string,
  domin: string,
  out_trade_no: string,
  setExportPercentage: (arg0: number) => void) {
  const workbook = new ExcelJS.Workbook()
  workbook.creator = 'opsloth-cms'
  workbook.created = new Date()
  workbook.modified = new Date()
  workbook.lastPrinted = new Date()
  workbook.properties.date1904 = true

  const sheet: any = workbook.addWorksheet(company)

  const columns: { name: string, width?: number, hidden?: boolean, totalsRowLabel?: string, totalsRowFunction?: string, fill?: any }[] = []
  headers.forEach((header, header_index) => {
    let widthTemp = 16
    if (headers_key[header_index] === 'name_jp') {
      widthTemp = 46
    } else if (headers_key[header_index] === 'order_number_pack' ||
      headers_key[header_index] === 'order_number_carton' ||
      headers_key[header_index] === 'pack_spec' ||
      headers_key[header_index] === 'carton_spec' ||
      headers_key[header_index] === 'order_price'
    ) {
      widthTemp = 12
    } else if (headers_key[header_index] === 'mainImage') {
      widthTemp = 14
    } else if (headers_key[header_index] === 'name_zh') {
      widthTemp = 30
    } else if (headers_key[header_index] === 'order') {
      widthTemp = 5
    }
    if (
      headers_key[header_index] === 'order_number_pack'
      || headers_key[header_index] === 'order_number_carton'
      || headers_key[header_index] === 'order_price'
    ) {
      columns.push({ name: header, width: widthTemp, totalsRowFunction: 'sum' })
    } else {
      columns.push({ name: header, width: widthTemp, totalsRowFunction: 'none' })
    }
  })

  const rows: (string | number | object)[][] = []
  let cargo_sent_cancled_count = 0
  // products.forEach((product: any, product_index: number) => {

  let productExportArray = products
  if (checkedSubproductArray.length > 0) {
    productExportArray = []
    checkedSubproductArray.sort().forEach(index => {
      productExportArray.push(products[index])
    })
  }
  for (let i = 0; i < productExportArray.length; i++) {
    const product = productExportArray[i]
    if (product['cargo_sent']?.indexOf('已取消') == -1 || !product['cargo_sent']) {
      setExportPercentage(parseFloat(((i / productExportArray.length) * 100).toFixed(1)))
      const product_index = i - cargo_sent_cancled_count
      // const imgBase64 = await downloadImgs(product.mainImage.replace('http://', 'https://')) as string
      const imgBase64: any = await imgTool.getBase64Image(imgTool.getSmallerImgUrl(product.mainImage))
      const imageIdTemp = workbook.addImage({
        base64: imgBase64 ?? minimal_base64_img,
        extension: 'png'
      })
      sheet.getRow(product_index + 2).height = 120
      sheet.getRow(product_index + 2).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      let row: (string | number | object)[] = []
      headers_key.forEach((header_item, cell_index: number) => {
        if (cell_index == 0) {
          row.push(product_index + 1)
        } else {
          if ((!isNaN(product[header_item]) && product[header_item] > 0) && (header_item === 'order_number_pack' || header_item === 'order_number_carton' || header_item === 'order_remark')) {
            sheet.getCell(`${ALPHABET[row.length]}${product_index + 2}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC5D9F1' } }
            sheet.getCell(`${ALPHABET[row.length]}${product_index + 2}`).border = { right: { style: 'thin', color: { argb: 'FFFFFFFF' } } };
          }
          if (header_item === 'order_price') {
            if (product.price_cny_cn === 0 && product.price_cny_jp === 0) {
              row.push('*价格')
            } else {
              if (isNaN(product[header_item])) {
                row.push("")
              } else {
                row.push({ formula: `O${product_index + 2}*Max(H${product_index + 2}, I${product_index + 2})`, result: product['real_number'] > 0 ? product['real_number'] * Math.max(product['price_cny_cn'], product['price_cny_jp']) : product[header_item] })
              }
              // row.push(product[header_item])
            }
          } else if (header_item === 'real_number') {
            if (product.real_number) {
              row.push(product[header_item])
            } else {
              // console.log(props.schema.category, product)
              if (category_label == '海关') {
                row.push(product.order_number_carton * product.carton_spec)
              } else {
                let real_number = (product.order_number_carton ?? 0) * (product.carton_spec ?? 0) + (product.order_number_pack ?? 0) * (product.pack_spec ?? 0)
                if (!isNaN(product.warehouse_stock)) {
                  real_number = calcStockAndPrice.calcStockAndPrice(
                    Math.max(product["price_cny_cn"] ?? 0, product["price_cny_jp"] ?? 0),
                    product["pack_spec"] ?? 0,
                    product["carton_spec"] ?? 0,
                    product["order_number_pack"] ?? 0,
                    product["order_number_carton"] ?? 0,
                    product["warehouse_stock"],
                    product["category"]
                  ).totalStock
                }
                // console.log(product)
                row.push(isNaN(real_number) ? "" : real_number)
              }
            }
          } else if (header_item === 'order_remark') {
            // if (category_label == '周边' || category_label == '手办') {
            row.push(product[header_item])
            // } else {
            // row.push(product[header_item])
            // }
          } else {
            row.push(product[header_item])
          }

        }
      })
      // row.push(product['double_checked'])
      rows.push(row)
      sheet.addImage(imageIdTemp, {
        tl: { col: 1, row: product_index + 1 },
        br: { col: 2, row: product_index + 2 },
        hyperlinks: {
          hyperlink: product.mainImage?.replace("cms-service.oss-cn-shanghai.aliyuncs.com", "cdn.cms.opsloth.com"),
          tooltip: product.mainImage?.replace("cms-service.oss-cn-shanghai.aliyuncs.com", "cdn.cms.opsloth.com")
        }
      })
    } else {
      cargo_sent_cancled_count++
    }
  }
  sheet.getRow(productExportArray.length + 2).style = { font: { size: 16, color: { theme: 4 } }, alignment: { vertical: 'middle', horizontal: 'center' } }
  rows.push(['', '', '', '', '', '', '', '', '', '', '', '', '', '', '物流费用', logistic_cny])
  let table = {
    name: `Sheet1`,
    ref: 'A1',
    headRow: false,
    totalsRow: true,
    style: {
      theme: 'TableStyleLight9',
      showRowStripes: true,
    },
    columns: columns,
    rows: rows,
  }
  sheet.columns = columns
  sheet.getRow(rows.length + 2).style = { font: { size: 16, color: { theme: 4 } }, alignment: { vertical: 'middle', horizontal: 'center' } }
  sheet.getCell(`A${rows.length + 2}`).style = { font: { size: 16, color: { theme: 4 } }, alignment: { vertical: 'middle', horizontal: 'left' } }
  sheet.getRow(1).style = {}
  sheet.getRow(1).height = 40
  sheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' }
  sheet.getRow(1).border = { left: { style: 'thin', color: { argb: 'FFFFFFFF' } }, };
  // console.log(table)
  sheet.addTable(table as any)

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], { type: "application/vnd.ms-excel" })
  savefile(`回单-${company ?? ''}-${new Date().toLocaleString().replaceAll('/', '-')}${(domin ?? "").replace("https://", "-").replace("store.", "").replace(".com/OrderConfirm", "").replaceAll(".", "-")}${out_trade_no ? '-' + out_trade_no : ''}.xlsx`, blob)
  setExportPercentage(0)
}

export default exportOrdersToExcel